import React from "react";
import { CheckCircle2, Plane, Clock, ShieldCheck, ArrowRight, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import BookingForm from "../components/BookingForm";
import SEO from "../components/SEO";

const AIRPORT_IMG = "https://customer-assets-4nw71qhi.emergentagent.net/job_brothers-taxi-web/artifacts/gmifdzt1_brothers%20taxi%20id4%20tirana%20airport.png";

const AirportTransfers = () => {
  const { t } = useLang();
  return (
    <>
      <SEO title={t.seo.airport.title} description={t.seo.airport.description} keywords={t.seo.airport.keywords} path="/airport-transfers" />

      <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 bg-zinc-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-50">
          <img src={AIRPORT_IMG} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/40 to-transparent" />
        </div>
        <div className="absolute top-1/2 right-10 w-40 h-40 checkered-fine opacity-30 -translate-y-1/2" />
        <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 anim-fade-up">
          <div className="bt-tag-yellow mb-6"><Plane className="h-3.5 w-3.5" /> TIA · Rinas</div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tighter text-white max-w-4xl">
            <span className="font-serif italic font-normal normal-case text-[#FFD500] block mb-2">{t.accents.noStress}</span>
            {t.airport.title}
          </h1>
          <p className="mt-6 text-zinc-300 text-xl max-w-3xl">{t.airport.subtitle}</p>
        </div>
      </section>

      <section className="bg-paper py-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <p className="text-zinc-700 text-lg leading-relaxed mb-10">{t.airport.description}</p>
            <ul className="space-y-4">
              {t.airport.features.map((f, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div className="h-7 w-7 rounded-full bg-[#FFD500] flex items-center justify-center flex-shrink-0 mt-0.5">
                    <CheckCircle2 className="h-4 w-4 text-zinc-900" strokeWidth={2.5} />
                  </div>
                  <span className="text-zinc-800 text-base font-medium">{f}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="bg-white border border-zinc-200 rounded-2xl p-5 shadow-taxi-card">
                <Clock className="h-7 w-7 text-zinc-900 mb-2" />
                <div className="font-display text-2xl font-black uppercase text-zinc-900 tracking-tight">75 min</div>
                <div className="text-zinc-500 text-xs uppercase tracking-widest font-bold">Lushnjë → TIA</div>
              </div>
              <div className="bg-[#FFD500] border border-zinc-200 rounded-2xl p-5 shadow-taxi-card">
                <ShieldCheck className="h-7 w-7 text-zinc-900 mb-2" />
                <div className="font-display text-2xl font-black uppercase text-zinc-900 tracking-tight">3,500 L</div>
                <div className="text-zinc-800 text-xs uppercase tracking-widest font-bold">{t.common.fixedPriceSedan}</div>
              </div>
              <div className="bg-zinc-900 text-white border border-zinc-200 rounded-2xl p-5 shadow-taxi-card">
                <Plane className="h-7 w-7 text-[#FFD500] mb-2" />
                <div className="font-display text-2xl font-black uppercase text-white tracking-tight">Live</div>
                <div className="text-zinc-400 text-xs uppercase tracking-widest font-bold">{t.common.flightTracking}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="bg-white border border-zinc-200 rounded-3xl overflow-hidden shadow-taxi-lift">
              <div className="bg-zinc-900 px-6 py-5">
                <div className="text-xs uppercase tracking-[0.2em] font-extrabold text-[#FFD500]">{t.airport.ctaTitle}</div>
                <div className="text-zinc-300 text-sm mt-1">{t.airport.ctaDesc}</div>
              </div>
              <BookingForm compact defaultService="airport" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-mist">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 text-center">
          <h3 className="font-display text-3xl md:text-5xl font-black uppercase text-zinc-900 mb-6 tracking-tighter">{t.home.ctaBlockTitle}</h3>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/book" className="bt-btn-primary">{t.common.bookTaxi} <ArrowRight className="h-4 w-4" /></Link>
            <a href="tel:+355682222286" className="bt-btn-outline"><Phone className="h-4 w-4" /> +355 68 22 22 286</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default AirportTransfers;
